import { ACTIVE, ONE_CLICK_CHECKOUT_BUTTON } from '../classnames/design-system';
import { SELECTORS } from './constants';

export class ProductCardOptions {
  constructor(container) {
    this.container = container;
    this.products = container.querySelectorAll(`.${SELECTORS.OPTION}`);
    this.button = container.querySelector(`.${ONE_CLICK_CHECKOUT_BUTTON}`);
  }

  handleClick = ({ currentTarget: { dataset: { productId, variantId, subscriptionId }}}) => {
    this.products.forEach((product) => {
      if (product.dataset.productId === productId) {
        product.classList.add(ACTIVE);

        this.button.dataset.productId = productId;
        this.button.dataset.variantId = variantId;
        this.button.dataset.subscriptionId = subscriptionId;
      } else {
        product.classList.remove(ACTIVE);
      }
    });
  };

  initializeEventListeners = () => {
    this.products.forEach((product) => product.addEventListener('click', this.handleClick));
  };
}
